import { theme } from "../../theme";
export const badgeSizeForm = {
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  contentWrapper: {
    height: "calc(100vh - 105px)",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  topActions: {
    display: "flex",
    alignItems: "center",
    paddingBottom: "20px",
  },
  infoTitle: {
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
  },
  saveButton: {
    marginLeft: "20px",
    marginRight: "15px",
  },
  formContent: {
    position: "relative",
    width: "100%",
    flexGrow: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    overflow: "auto",
  },
  genericFields: {
    width: "50%",
    height: "100%",
    backgroundColor: theme.palette.grey[600],
    overflow: "auto",
    borderRadius: "5px",
  },
  useCases: {
    width: "45%",
    height: "100%",
    backgroundColor: theme.palette.grey[600],
    overflow: "auto",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
  },
  formFields: {
    padding: "10px 20px",
    textAlign: "left",
  },
  checkbox: {
    color: theme.palette.grey["800"],
  },
  // textFieldWithAdornment: {
  //   marginBottom: "15px",

  //   "& input": {
  //     padding: "6px 30px 6px 7px",
  //   },
  // },
  inputIcon: {
    fontSize: "18px",
    color: theme.palette.grey["800"],
  },
  useCaseChip: {
    marginBottom: "5px",
    marginRight: "5px",
  },
  inputWithAdornment: {
    '& .MuiInputBase-adornedEnd': {
      p:0,
      backgroundColor:'transparent',
      border:0,
      boxShadow:'none',
      '& input': {
        width: '100%',
        border: '1px solid #E7E7E7',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
        borderRadius: '6px!important',
        background: '#fff',
        padding: '12px 10px',
        position: 'relative',
        paddingRight: '14px',
      }
    }
  },
};

export const badgeSizeView = {
  listContent: {
    position: "relative",
    width: "100%",
    flexGrow: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    overflow: "auto",
  },
  topFilters: {
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  searchForm: {
    padding: "0px 10px",
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
    boxShadow: "0px 4px 8px rgb(0 0 0 / 5%)",
    border: "1px solid #E7E7E7",
    borderRadius: "6px",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRight: 0,
  },
  searchInput: {
    flex: 1,
    border: 0,
    boxShadow: "none",
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    "&.MuiFormControl-root": {
      m: 0,
    },
    "& .MuiInputBase-root": {
      padding: "9px 10px 9px 10px",
      borderTopRightRadius: "0 !important",
      borderBottomRightRadius: "0 !important",
    },
  },
  clearIcon: {
    cursor: "pointer",
  },
  searchButton: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: "5px",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: "5px",
  },
};